module.exports = new __parcel__URL__("runes.49e40666.jpeg").toString();